// Compact product catalog keyed by ingredient slug. A subset of the iOS catalog —
// just enough to surface a real product per priority ingredient on the plan page.
export interface Product {
  name: string;
  brand: string;
  price: string;
  url: string;
}

const CATALOG: Record<string, Product> = {
  vitamin_c: {
    name: '15% Vitamin C + EFA',
    brand: "Paula's Choice",
    price: '$49',
    url: 'https://www.paulaschoice.com/c15-super-booster/8210.html',
  },
  retinol: {
    name: 'Retinol 0.3 + Lactic Acid',
    brand: 'The Ordinary',
    price: '$10',
    url: 'https://theordinary.com/en-us/retinol-0-2-in-squalane-serum-100422.html',
  },
  niacinamide: {
    name: 'Niacinamide 10% + Zinc 1%',
    brand: 'The Ordinary',
    price: '$7',
    url: 'https://theordinary.com/en-us/niacinamide-10-zinc-1-serum-100436.html',
  },
  hyaluronic_acid: {
    name: 'Hyaluronic Acid 2% + B5',
    brand: 'The Ordinary',
    price: '$9',
    url: 'https://theordinary.com/en-us/hyaluronic-acid-2-b5-hydration-support-formula-100433.html',
  },
  ceramides: {
    name: 'Daily Moisturizing Lotion',
    brand: 'CeraVe',
    price: '$15',
    url: 'https://www.cerave.com/skincare/moisturizers/daily-moisturizing-lotion',
  },
  ceramide_moisturizer: {
    name: 'Daily Moisturizing Lotion',
    brand: 'CeraVe',
    price: '$15',
    url: 'https://www.cerave.com/skincare/moisturizers/daily-moisturizing-lotion',
  },
  peptides: {
    name: 'Buffet Multi-Peptide Serum',
    brand: 'The Ordinary',
    price: '$15',
    url: 'https://theordinary.com/en-us/buffet-multi-technology-peptide-serum-100427.html',
  },
  salicylic_acid: {
    name: '2% BHA Liquid Exfoliant',
    brand: "Paula's Choice",
    price: '$34',
    url: 'https://www.paulaschoice.com/skin-perfecting-2pct-bha-liquid-exfoliant/2010.html',
  },
  azelaic_acid: {
    name: 'Azelaic Acid 10%',
    brand: 'The Ordinary',
    price: '$11',
    url: 'https://theordinary.com/en-us/azelaic-acid-suspension-10-100400.html',
  },
  spf: {
    name: 'Unseen Sunscreen SPF 40',
    brand: 'Supergoop!',
    price: '$38',
    url: 'https://supergoop.com/products/unseen-sunscreen',
  },
  gentle_cleanser: {
    name: 'Hydrating Facial Cleanser',
    brand: 'CeraVe',
    price: '$16',
    url: 'https://www.cerave.com/skincare/cleansers/hydrating-facial-cleanser',
  },
};

export function recommendedProduct(slug: string): Product | null {
  return CATALOG[slug] ?? null;
}
